import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #0F1927;
  flex: 1 0 auto;
  overflow: hidden;
`;

export default Container;
